/**
 * 自增id
 * @return {Function} return number
 * @category Function
 */
var incrementId = function incrementId() {
  var id = 0;
  return function () {
    return id++;
  };
};

export default incrementId;